import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useSelector } from 'react-redux';
import { useApiMutation } from './useApiMutation';

const useDeleteInsightRule = (options = {}) => {
  const trans = useSelector(translator);
  const insightRulesApi = useSelector((state) => state.apis.insightRulesApi);
  const { ...mutationOptions } = options;

  return useApiMutation(
    ({ useruuid, ruleuuid, successCallback, errorCallback }) =>
      new Promise((resolve, reject) => {
        insightRulesApi.removeInsightRule(
          useruuid,
          ruleuuid,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              successCallback(data);
              resolve(data);
            },
            errorCallback: (err) => {
              errorCallback(err);
              reject(err);
            },
          })
        );
      }),
    {
      ...mutationOptions,
      invalidateKeys: [['getInsightRules']],
    }
  );
};

export default useDeleteInsightRule;
